import React, {useState, useEffect, useRef}  from 'react'
import {Select,} from 'antd';
import {reqCabinetTypes,} from "../api";
import {DELIVERY_TYPE_HIGHWAY,} from "../utills/constants";
export default function CabinetTypeSelect(props) {
    const [cabinetTypes, setCabinetTypes] = useState([]);
    const [options, setOptions] = useState([]);
    const ref = useRef();
    useEffect(() => {
        if (props.deliveryType) {
            getCabinetTypes(props.deliveryType);
        }
    }, [props.deliveryType]);
    useEffect(() => {
        //切换服务模式时
        if (ref.current && props.subType) {
            props.setFieldsValue({cabinetType: props.subType !== 'B' ? 'HQ' : ''})
        }
        ref.current = props.subType;
    }, [props.subType]);
    useEffect(() => {
        const options = [];
        if (Array.isArray(cabinetTypes) && cabinetTypes.length >= 0) {
            cabinetTypes.forEach(o => {
                options.push(<Select.Option key={o.cabinetType}
                                            value={o.cabinetType}>{o.cabinetTypeName}</Select.Option>)
            });
        }
        setOptions(options);
    }, [cabinetTypes]);
    const getCabinetTypes = async (deliveryType) => {
        const result = await reqCabinetTypes(deliveryType);
        if (result.code === 200) {
            setCabinetTypes(result.data);
        }
    };
    return props.getFieldDecorator('cabinetType', {
        initialValue: !!props.initialValue ? props.initialValue : (props.subType !== 'B' ? 'HQ' : ''),
    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}
               disabled={props.disabled} style={{minWidth: '80px'}}
               allowClear={DELIVERY_TYPE_HIGHWAY.hasOwnProperty(props.deliveryType) && props.subType === 'B'}>
            {options}
        </Select>
    )
}